
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse,HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VisitorServiceService {

  constructor(
    private http: HttpClient
  ) { 

  }
 
  getIpAddress() {
    // Using MaxMind's geoip-js.com service - returns IP and location in one call
    return this.http
          .get('https://geoip-js.com/geoip/v2.1/city/me', {
            headers: new HttpHeaders({
              'Accept': 'application/json'
            })
          })
          .pipe(
            catchError(this.handleError)
          );
  }

   getGEOLocation(ip:any) {
  // Using MaxMind's geoip-js.com service - this method is kept for backward compatibility
  // but now calls the same endpoint since MaxMind provides all data in one call
    return this.http
          .get('https://geoip-js.com/geoip/v2.1/city/me', {
            headers: new HttpHeaders({
              'Accept': 'application/json'
            })
          })
          .pipe(
            catchError(this.handleError)
          );
  } 

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

}